const mapper_options = {
  upsert: false,
  endpoint: 'reporting/pulse/locations',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      retailer: {
        foreignKey: 'retailer_id',
        localField: 'retailer'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('pulse_location', mapper_options)
}
